import { Layout as AntDLayout } from "antd";
import { Outlet } from "react-router-dom";
import { PageHeader } from "src/components/PageHeaders/PageHeaders";
import SideBar from "src/components/SideBar/SideBar";

const { Content } = AntDLayout;

export default function Layout() {
  return (
    <AntDLayout>
      <AntDLayout
        style={{
          transition: "all 0.2s",
        }}
      >
        <SideBar />
        <Content className="bg-cmsBg flex flex-col min-h-screen overflow-x-hidden">
          <div className="centered-container flex-1 my-8">
            <PageHeader />
            <Outlet />
          </div>
        </Content>
      </AntDLayout>
    </AntDLayout>
  );
}
